import { SellingPlan } from '../../models/selling-plan'

export const sortingByName = (plan1: SellingPlan, plan2: SellingPlan) => {
  if (plan1.name > plan2.name) {
    return 1
  } else if (plan1.name < plan2.name) {
    return -1
  }
  return 0
}
